<template>
    <section class="inline welcome large bg-brand">
        <div class="grid gap-3 fixed fixed-max-sm middle xs-grid-cols-1 sm-grid-cols-2 ">
            <div class="img">
                <img :src="imgSrc" alt="Welcome Home Movoto" fetchpriority="auto"/>
            </div>
            <div class="flex vertical large top center">
                <h1 class="f0 text-bold" v-if="glb.geo.city">Sell My Home Fast And For More In {{glb.geo.city}}, {{glb.geo.state}}</h1>
                <h1 class="f0 text-bold" v-else>Sell Your Home with {{local}} Real Estate Experts</h1>
                <div>Movoto partners with the best {{local}} listing agents.</div>
                <mvtInputGeo class="large" ref="addressInput" v-model="geoInfo" :placeholder="glb.isPhone ? 'Enter Address' : 'Enter Your Home Address'"  :options="{types:['address']}">Get Started</mvtInputGeo>
            </div>
        </div>
    </section>
</template>

<script src="./sell-welcome.js"></script>

<style lang="scss">
@use "./sell-welcome.scss" as *;
</style>
